<script setup lang="ts">
import { adminUrlFor } from '~/utils/admin-url'

const config = useRuntimeConfig().public
const adminUrl = adminUrlFor(config.CONSOLE_API_BASE_URL)
const open = ref(true)
</script>

<template>
  <UiDialog v-model="open" max-width="480px" persistent>
    <header class="p-4">
      <h2 class="h2">Policy Manager is deprecated</h2>
    </header>
    <p class="body-1 px-4">
      Policy Manager has been replaced by the Rialtic Admin app. Please use
      Admin going forward; Policy Manager is no longer maintained.
    </p>
    <footer class="flex justify-end space-x-4 p-4">
      <UiButton variant="text" @click="open = false">
        Continue to Policy Manager
      </UiButton>
      <a
        class="btn bg-secondary text-button-2 hover:bg-secondary-800 text-white"
        :href="adminUrl"
      >
        Go to Admin
      </a>
    </footer>
  </UiDialog>
</template>
